export default "__VITE_ASSET__4f66d5fd__"